import { createModalStore } from '@/shared/lib/modal';

export const useNotAccessModal = createModalStore({}, false);
